import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ZorbaButton } from '../../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../../components/forms/ZorbaButton/constants';
import { MODAL_ADD_ASSET } from '../../../../reducers/Modal/types';
import { setModalState } from '../../../../reducers/Modal/actions';
import { MyAssetsTable } from './Components/MyAssetsTable';
import { AddAssetModal } from './Components/AddAssetModal';
import { fetchEntitites } from '../../../../reducers/Entities/actions';

import './index.scss';

export const MyAssets = () => {
  const dispatch = useDispatch();
  const handleOpenModal = () => {
    dispatch(setModalState(MODAL_ADD_ASSET, true));
  };
  const { isFetchingEntities } = useSelector(
    ({ EntitiesReducer }) => EntitiesReducer,
  );

  useEffect(() => {
    dispatch(fetchEntitites());
  }, []);

  return (
    <>
      <div className="button-container">
        <ZorbaButton
          variant={BUTTON_VARIANT_DARK}
          onClick={handleOpenModal}
          fullWidth={false}
          disabled={isFetchingEntities}
        >
          + Import asset
        </ZorbaButton>
      </div>
      <MyAssetsTable />
      <AddAssetModal />
    </>
  );
};
